'use strict';

export default function (url, isGetRoot) {
  // 第一个方法删除
  if (!isGetRoot) {
    let array = ['facebook', 'bing', 'linkedin', 'twitter', 'google', 'skype', 'pinterest','youtube','instagram'];
    let res = "";
    for (let i = 0; i < array.length; i++) {
      if (_.includes(url, array[i])) {
        res = array[i];
        break;
      }
    }
    return res ? _.capitalize(res) : null;
  } else {
    let regex = /^(?:https?:\/\/)?([\w.-]+(?:\.[\w.-]+)+)(?:[\w-._~:/?#[\]@!$&'()*+,;=]*)$/ig;
    let urlArray =  regex.exec(url);
    if(urlArray instanceof Array){
      return urlArray[1];
    }else{
      return url;
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/filters/url-format.js